import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/LegalPages.css';

const TermsOfUse = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1 className="legal-title">Terms of Use</h1>
        <p className="effective-date">Last Updated: February 4, 2026</p>

        <div className="legal-content">
          <p className="intro-text">
            Welcome to the website of One Aligned, Inc. ("One Aligned," "we," "our," or "us"). By accessing or using this website, you agree to the following Terms of Use. If you do not agree, please do not use the site.
          </p>

          <section className="legal-section">
            <h2>Use of Website</h2>
            <p>
              This website is provided for informational purposes only. You may use the site solely for lawful purposes and in a manner consistent with these Terms.
            </p>
            <p>You agree not to:</p>
            <ul>
              <li>Use the website in any way that violates applicable laws or regulations</li>
              <li>Attempt to gain unauthorized access to the website or its systems</li>
              <li>Interfere with the security, functionality, or availability of the website</li>
              <li>Use the website to transmit malicious code or harmful content</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>Intellectual Property</h2>
            <p>
              All content on this website — including text, graphics, logos, images, and other materials — is the property of One Aligned, Inc. or its licensors and is protected by applicable intellectual property laws.
            </p>
            <p>
              You may view, download, or print content for personal or internal business use only. You may not reproduce, distribute, modify, or publicly display content without prior written permission from One Aligned, Inc.
            </p>
          </section>

          <section className="legal-section">
            <h2>No Professional or Contractual Advice</h2>
            <p>
              Information provided on this website does not constitute legal, financial, technical, or professional advice and does not create a client, advisory, or contractual relationship.
            </p>
            <p>
              Any services offered by One Aligned are governed solely by written agreements executed by authorized parties.
            </p>
          </section>

          <section className="legal-section">
            <h2>Third-Party Links</h2>
            <p>
              This website may contain links to third-party websites for convenience or reference. One Aligned does not control and is not responsible for the content, security, or privacy practices of third-party sites.
            </p>
          </section>

          <section className="legal-section">
            <h2>Disclaimer of Warranties</h2>
            <p>
              This website is provided "as is" and "as available." One Aligned makes no warranties, express or implied, regarding the accuracy, completeness, or reliability of the website or its content.
            </p>
          </section>

          <section className="legal-section">
            <h2>Limitation of Liability</h2>
            <p>
              To the fullest extent permitted by law, One Aligned, Inc. shall not be liable for any direct, indirect, incidental, consequential, or special damages arising out of or related to the use of this website.
            </p>
          </section>

          <section className="legal-section">
            <h2>Privacy</h2>
            <p>
              Your use of the website is also governed by our <Link to="/privacy-policy" className="legal-link">Privacy Policy</Link>, which describes how we collect and use information.
            </p>
          </section>

          <section className="legal-section">
            <h2>Changes to These Terms</h2>
            <p>
              One Aligned may update these Terms of Use at any time. Changes will be effective upon posting to the website. Continued use of the site constitutes acceptance of the updated Terms.
            </p>
          </section>

          <section className="legal-section">
            <h2>Governing Law</h2>
            <p>
              These Terms are governed by and construed in accordance with the laws of the United States and the state in which One Aligned, Inc. is incorporated, without regard to conflict-of-law principles.
            </p>
          </section>

          <section className="legal-section">
            <h2>Contact Information</h2>
            <p>If you have questions about these Terms of Use, please contact:</p>
            <div className="contact-info">
              <p><strong>One Aligned, Inc.</strong></p>
              <p>📧 <a href="mailto:info@onealigned.com" className="legal-link">info@onealigned.com</a></p>
              <p>🌐 <a href="https://www.onealigned.com" className="legal-link" target="_blank" rel="noopener noreferrer">www.onealigned.com</a></p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfUse;
